import { useTranslation } from 'react-i18next'
import { PiArrowsClockwise, PiCheckCircle, PiWarning } from 'react-icons/pi'

import { useDriveStore } from '@/store/useDriveStore'

import type { DriveCopyStatus } from '@/types/expense'

import GoogleDriveIcon from './GoogleDriveIcon'

interface DriveItemChipProps {
  status: DriveCopyStatus
  interactive?: boolean
  showLabel?: boolean
}

export const DriveItemChip = ({ status, interactive = true, showLabel = true }: DriveItemChipProps) => {
  const { t } = useTranslation()

  const openSheet = useDriveStore((state) => state.openSheet)

  const { label, state, tone } =
    status === 'pending'
      ? { label: t('expenses.drive.chip.uploading'), state: <PiArrowsClockwise className="w-3 h-3 animate-spin" />, tone: 'text-zinc-500' }
      : status === 'failed'
        ? { label: t('expenses.drive.chip.notSynced'), state: <PiWarning className="w-3 h-3 text-amber-500" />, tone: 'text-amber-700' }
        : { label: t('expenses.drive.chip.synced'), state: <PiCheckCircle className="w-3 h-3 text-emerald-500" />, tone: 'text-zinc-500' }

  const inner = (
    <>
      <GoogleDriveIcon className="w-3 h-3" />
      {showLabel && label}
      {state}
    </>
  )

  const className = `inline-flex items-center gap-1 text-xs whitespace-nowrap ${tone}`

  if (!interactive) {
    return <span className={className}>{inner}</span>
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        openSheet()
      }}
      className={className}
    >
      {inner}
    </button>
  )
}

export default DriveItemChip
